// SubjectDetails.jsx

import { useParams, useNavigate, Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Loader from '../components/Spinner';
import { FaSignInAlt, FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube } from 'react-icons/fa';


const SubjectDetails = () => {
  const { id: subjectId } = useParams();
  const [subject, setSubject] = useState(null)
  const [isPurchased, setIsPurchased] = useState(false)
  const [loading, setLoading] = useState(true)
  const [scrolled, setScrolled] = useState(false);
  const [subjects, setSubjects] = useState([]);
  const [showModules, setShowModules] = useState(false);
const [modules, setModules] = useState([]);
const [subjectName, setSubjectName] = useState("");
const [selectedModule, setSelectedModule] = useState(null);
const [components, setComponents] = useState([]);
const [selectedComponent, setSelectedComponent] = useState(null);
const [contentHTML, setContentHTML] = useState("");
  const contentRef = useRef();
  const [quizResult, setQuizResult] = useState(null);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [userAnswerIndex, setUserAnswerIndex] = useState(null);
  const [showExplanation, setShowExplanation] = useState(false);
  const [score, setScore] = useState(0);
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [hasAccess, setHasAccess] = useState(false);
  const [subjectPrice, setSubjectPrice] = useState(300);
  const [completed, setCompleted] = useState([]);
  const [isDarkMode, setIsDarkMode] = useState(() => localStorage.getItem('theme') === 'dark');

  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch subject details by ID
    const fetchSubject = async () => {
      const res = await axios.get(`https://backend.scholarkart.in/api/subjects/${subjectId}`)
      setSubject(res.data)
      setIsPurchased(res.data.isPurchased) // Example flag
      setLoading(false)
    }
    fetchSubject()
  }, [subjectId])



  useEffect(() => {
    document.documentElement.classList.toggle("dark", isDarkMode);
    localStorage.setItem("theme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  useEffect(() => {
    if (subjectId) {
      axios.get(`https://backend.scholarkart.in/api/modules?subjectId=${subjectId}`).then((res) => setModules(res.data));
      axios.get(`https://backend.scholarkart.in/api/subjects/${subjectId}`)
      .then((res) => {
        setSubjectName(res.data.subjectName);
        setSubjectPrice(res.data.price); // 💰
      });
      if (user?._id) {
        axios.get(`https://backend.scholarkart.in/api/users/${user._id}/completed-submodules`).then(res => setCompleted(res.data));
      }
    }
  }, [subjectId]);

  // Check if user has access to the subject
  useEffect(() => {
    const checkAccess = async () => {
      if (subjectId && user?._id) {
        if (user.collegeId) {
          try {
            const res = await axios.get(`https://backend.scholarkart.in/api/college-course-access/${user.collegeId}/${subjectId}`);
            if (res.data.access) {
              setHasAccess(true);
              return;
            }
          } catch (err) {
            console.error("Institutional access check failed:", err);
          }
        }
  
        // Fallback to personal purchase check
        const res = await axios.get(`https://backend.scholarkart.in/api/user/${user._id}/premium-subjects`);
        setHasAccess(res.data.subjectIds.includes(subjectId));
      }
    };
  
    checkAccess();
  }, [subjectId, user?._id]);
  
  

  const handleModuleClick = async (module) => {
    setSelectedModule(module);
    const res = await axios.get(`https://backend.scholarkart.in/api/submodules?moduleId=${module._id}`);
    setComponents(res.data);
    setSelectedComponent(null);
    setShowModules(false);
  };



  if (loading) return <Loader />



 const handleComponentClick = async (comp) => {
    setSelectedComponent(comp);
    const contentUrls = comp?.contentUrls || (comp?.contentUrl ? [comp.contentUrl] : []);

    const htmlUrl = contentUrls.find(url => url.endsWith(".html") || url.endsWith(".htm"));
    if (htmlUrl) {
      const res = await fetch(htmlUrl);
      const html = await res.text();
      setContentHTML(html);
    }

    if (comp.submoduleType === "Quiz") {
      const res = await axios.get(`https://backend.scholarkart.in/api/quiz/${comp._id}`);
      setQuizResult(res.data);
      setCurrentQuestionIndex(0);
      setUserAnswerIndex(null);
      setShowExplanation(false);
      setScore(0);
      setQuizCompleted(false);
    }
    

    if (user?._id) {
      await axios.post(`https://backend.scholarkart.in/api/users/${user._id}/complete-submodule`, {
        moduleId: selectedModule._id,
        submoduleId: comp._id
      });
      setCompleted(prev => [...prev, comp._id]);
    }
  };

  const saveForOffline = async (urls, id) => {
    if (!Array.isArray(urls)) urls = [urls];
    const allText = await Promise.all(urls.map(async url => {
      const res = await fetch(url);
      return await res.text();
    }));
    localStorage.setItem(`offline_${id}`, JSON.stringify(allText));
    alert("Saved for offline reading!");
  };

  const renderContent = () => {
    if (!selectedComponent) return <div className="text-center p-10">Select a Learning Component</div>;

    if (selectedComponent.submoduleType === "Quiz" && quizResult?.questions?.length) {
      const currentQuestion = quizResult.questions[currentQuestionIndex];

      const handleOptionClick = (index) => {
        setUserAnswerIndex(index);
        setShowExplanation(true);
        if (index === currentQuestion.correctAnswerIndex) {
          setScore(score + 1);
        }
      };

      const handleNext = () => {
        if (currentQuestionIndex + 1 < quizResult.questions.length) {
          setCurrentQuestionIndex(currentQuestionIndex + 1);
          setUserAnswerIndex(null);
          setShowExplanation(false);
        } else {
          setQuizCompleted(true);
        }
      };

      if (quizCompleted) {
        return (
          <div className="p-6 bg-white dark:bg-gray-800 rounded shadow text-center">
            <h3 className="text-lg font-bold text-green-600">🎉 Quiz Completed!</h3>
            <p className="mt-2 text-lg text-gray-700 dark:text-gray-300">
              Your Score: {score} / {quizResult.questions.length}
            </p>
          </div>
        );
      }


      return (
        <div className="p-4 bg-white dark:bg-gray-800 rounded-lg shadow">
          <h3 className="text-lg font-bold mb-4 text-[#055862] dark:text-orange-400">Self-Assessment Quiz</h3>
          <p className="font-medium mb-2">{currentQuestionIndex + 1}. {currentQuestion.questionText}</p>
          <ul className="list-disc pl-5 space-y-2">
            {currentQuestion.options.map((opt, i) => (
              <li
                key={i}
                onClick={() => !showExplanation && handleOptionClick(i)}
                className={`cursor-pointer p-2 rounded ${
                  userAnswerIndex === i
                    ? i === currentQuestion.correctAnswerIndex
                      ? 'bg-green-200'
                      : 'bg-red-200'
                    : 'hover:bg-gray-100 dark:hover:bg-gray-700'
                }`}
              >
                {opt}
              </li>
            ))}
          </ul>
          {showExplanation && (
            <div className="mt-4 text-sm text-gray-700 dark:text-gray-300">
              <p className="text-green-700 font-semibold">
                ✅ Correct Answer: {currentQuestion.options[currentQuestion.correctAnswerIndex]}
              </p>
              {currentQuestion.explanation && (
                <p className="mt-1 italic">Explanation: {currentQuestion.explanation}</p>
              )}
              <button
                onClick={handleNext}
                className="mt-4 bg-[#055862] hover:bg-teal-700 text-white px-4 py-1 rounded"
              >
                Next Question
              </button>
            </div>
          )}

        </div>
      );
    }

    const contentUrls = selectedComponent?.contentUrls || (selectedComponent?.contentUrl ? [selectedComponent.contentUrl] : []);

    const isAllHTML = contentUrls.every(url => url.endsWith(".html") || url.endsWith(".htm"));
    const isAllPDF = contentUrls.every(url => url.endsWith(".pdf"));
    const isAllYouTube = contentUrls.every(url => url.includes("youtube.com/embed/"));

    if (isAllHTML) {
      return (
        <div
          ref={contentRef}
          className="prose prose-sm md:prose-lg dark:prose-invert max-w-none list-disc list-outside [&>ul]:list-disc [&>ul]:pl-5"
          dangerouslySetInnerHTML={{ __html: contentHTML }}
        />
      );
    } else if (isAllPDF) {
      return contentUrls.map((url, idx) => (
        <iframe
          key={idx}
          src={url}
          className="w-full h-[80vh] mb-6 rounded-lg shadow"
          title={`PDF Viewer ${idx + 1}`}
        />
      ));
    } else if (isAllYouTube) {
      return (
        <div className="space-y-6">
          {contentUrls.map((url, idx) => (
            <div key={idx} className="relative w-full" style={{ paddingBottom: '56.25%', height: 0 }}>
              <iframe
                src={url}
                className="absolute top-0 left-0 w-full h-full rounded-lg shadow"
                title={`YouTube Video ${idx + 1}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          ))}
        </div>
      );
    } else {
      return <div className="p-10">Unsupported file type.</div>;
    }
  };

  const startPayment = async () => {
    try {
      const res = await axios.post('https://backend.scholarkart.in/api/payment/order', {
        subjectId,
        userId: user._id
      });
  
      const options = {
        key: "rzp_live_kKWBg4Hh617Za6", // Replace with real key
        amount: res.data.amount,
        currency: "INR",
        name: "eBrary.guru",
        description: "Access to eLearning Module",
        order_id: res.data.id,
        handler: async (response) => {
          // Save to DB after payment success
          await axios.post(`https://backend.scholarkart.in/api/payment/success`, {
            userId: user._id,
            subjectId,
            paymentInfo: response
          });
          alert("🎉 Payment successful! Access granted.");
          setHasAccess(true);
        },
        prefill: {
          name: user.displayname,
          email: user.email
        },
        theme: {
          color: "#ff7a00"
        }
      };
  
      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (error) {
      console.error("Payment initiation failed", error);
      alert("Payment failed. Please try again.");
    }
  };

  const contentUrls = selectedComponent?.contentUrls || (selectedComponent?.contentUrl ? [selectedComponent.contentUrl] : []);
 
let chapterIndex = 0;

  return (
    <div className="bg-white text-gray-800 dark:bg-gray-900 dark:text-white">
      {/* Header */}
      <header className={`fixed top-0 z-50 w-full transition-all duration-300 ${scrolled ? 'bg-gradient-to-r from-[#023a87] to-[#012f6e]' : 'bg-white dark:bg-gray-900'}`}>
        <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
          <a href="/">
          <div className="flex items-center gap-2">
            <img src={scrolled ? "/eBrary.png" : "/eBrary_Logo.png"} alt="Logo" className="h-12 w-auto transition duration-300" />
          </div>
          </a>
            <nav className="hidden md:flex gap-6 font-medium">
              <Link to="/#features" className={`font-bold hover:text-[#ff7a00] transition duration-200 ${scrolled ? 'text-white' : 'text-[#023a87]'}`}>Key Features</Link>
              <Link to="/#institutions" className={`font-bold hover:text-[#ff7a00] transition duration-200 ${scrolled ? 'text-white' : 'text-[#023a87]'}`}>For Institutions</Link>
              <Link to="/#subjects" className={`font-bold hover:text-[#ff7a00] transition duration-200 ${scrolled ? 'text-white' : 'text-[#023a87]'}`}>Popular Courses</Link>
              <Link to="/#stats" className={`font-bold hover:text-[#ff7a00] transition duration-200 ${scrolled ? 'text-white' : 'text-[#023a87]'}`}>Statistics</Link>
            </nav>
          <div>
          <Link to="/LoginPage">
            <button className={`px-6 py-2 rounded-full flex items-center gap-x-2 transition duration-200 ${scrolled ? 'bg-white text-blue-600 hover:bg-gray-100' : 'bg-[#ff7a00] text-white hover:bg-orange-600'}`}>
              <FaSignInAlt />
              <span>Login</span>
            </button>
          </Link>
          </div>
        </div>
      </header>



      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#023a87] to-[#012f6e] text-white pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-2 gap-10 items-center">
          
          {/* Left Side: Text and Actions */}
          <div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-amber-400 leading-tight mb-4">{subject.subjectName}</h1>
            <div className="flex items-center gap-4 mb-4">
              
              {!hasAccess && (
                <>
                <span className="text-3xl font-bold text-orange-500">₹{subject.price || 99} one-time</span>
                <button 
                  onClick={startPayment}
                  className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 py-2 rounded-full"
                >
                  Buy Now
                </button>
                </>
              )}
              {hasAccess && (
                <Link
                  to={`/elearning/${subject._id}`}
                  className="inline-block w-full bg-green-600 text-white text-center py-2 rounded-full hover:bg-green-700 transition"
                >
                  Access Course
                </Link>
              )}
            </div>
            <p className="text-lg text-gray-300 mb-6">{subject.subjectOutcome || 'Explore the complete syllabus with lecture notes, videos, quizzes, and past papers.'}</p>

          </div>

          {/* Right Side: Image/Illustration */}
            {subject.courseIds?.map((course, index) => (
              <div key={index} className="mt-6 bg-white/10 p-4 rounded-lg border border-white/10">
                <h2 className="text-xl font-bold text-white mb-2">{course.courseName}</h2>
                <p className="text-gray-300 mb-1">Affiliation: <span className="text-white">{course.affiliation}</span></p>
                <p className="text-gray-300 mb-1">Subject: <span className="text-white">{subject.subjectName}</span></p>
                <img 
                  src={subject.coverImage}
                  alt={subject.subjectName} 
                  className="rounded-lg shadow-lg w-full max-w-md"
                />
              </div>
            ))}
        </div>
      </section>



<div className="flex flex-col md:flex-row h-screen overflow-hidden bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      {/* Module Panel */}
      {(showModules || window.innerWidth >= 768) && (
        <div className="w-full md:w-1/4 bg-[#f7f7f7] dark:bg-[#1e293b] border-r border-gray-300 dark:border-gray-700 overflow-y-auto p-4 md:pt-8">

          <h2 className="text-lg font-bold mb-4 text-[#033D7A] dark:text-orange-400">{subject.subjectName || "Subject"}</h2>
          {modules.map((mod) => {
            const currentChapter = chapterIndex;
            chapterIndex++; // increment only once per module

            return (
              <div key={mod._id} className="mb-4">
              <button
                onClick={() => handleModuleClick(mod)}
                className={`block w-full text-left p-2 rounded-lg transition-all text-sm font-semibold shadow-sm
                  ${selectedModule?._id === mod._id
                    ? "bg-[#ff7a00] text-white"
                    : "bg-white dark:bg-gray-800 text-gray-800 dark:text-white border border-gray-300 dark:border-gray-600 hover:bg-orange-100 dark:hover:bg-orange-800"}`}
              >
                  {mod.moduleName}
                </button>

                {selectedModule?._id === mod._id && components.length > 0 && (
                  <div className="mt-2 pl-3">
                    {components.map((comp) => {
                      const isLocked = !hasAccess && currentChapter >= 1;

                      return (
                        <div key={comp._id} className="flex items-center justify-between">
                          <button
                            disabled={isLocked}
                            onClick={() => !isLocked && handleComponentClick(comp)}
                            className={`block w-full text-left text-sm py-1 px-2 ${
                              isLocked
                                ? 'text-gray-400 cursor-not-allowed'
                                : 'hover:text-[#ff7a00] text-gray-700 dark:text-gray-300'
                            }`}
                          >
                            ▸ {comp.submoduleType.replace(/([A-Z])/g, ' $1')}
                          </button>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}

        </div>
      )}

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto p-4 md:p-8 bg-white dark:bg-gray-900 transition-colors duration-300">
        {selectedModule && (
          <div className="mb-6">
            <h2 className="text-xl font-bold text-[#055862] dark:text-orange-400">
              {selectedModule.moduleName}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 text-sm">{selectedModule.moduleDescription}</p>
          </div>
        )}

        {renderContent()}
      </main>
    </div>





      {/* Footer */}
      <footer className="bg-gradient-to-r from-[#012f6e] to-[#023a87] text-white py-10 backdrop-blur-sm shadow-inner">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-[2fr_1fr_1fr_1fr] gap-10">
          {/* Logo & Description */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <img src="/eBrary.png" alt="eBrary Logo" className="h-12 w-auto" />
            </div>
            <p className="text-sm text-gray-300">
            eBrary.guru is an innovative Digital Library and eLearning platform designed to 
          support students with global eBrary, featuring the largest collection of eBooks and 
          eJournals, as well as a campus eBrary with textbooks and reference 
          books for all subjects. An AI-powered chatbot enhances the eLearning 
          experience by answering student's any question from the textbooks.
            </p>
          </div>

          {/* eBrary Modules with hover animation */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-amber-400">eBrary Modules</h4>
            <ul className="text-sm space-y-2 text-gray-300">
              <li>
                <a
                  href="/mycourse"
                  className="relative inline-block after:block after:h-[2px] after:bg-amber-400 after:scale-x-0 after:transition-transform after:origin-left hover:after:scale-x-100"
                >
                  My Courses
                </a>
              </li>
              <li>
                <a
                  href="/mylibrary"
                  className="relative inline-block after:block after:h-[2px] after:bg-amber-400 after:scale-x-0 after:transition-transform after:origin-left hover:after:scale-x-100"
                >
                  My Library
                </a>
              </li>
              <li>
                <a
                  href="/ebrarycollection"
                  className="relative inline-block after:block after:h-[2px] after:bg-amber-400 after:scale-x-0 after:transition-transform after:origin-left hover:after:scale-x-100"
                >
                  eBrary Collection
                </a>
              </li>
              <li>
                <a
                  href="/ejournals"
                  className="relative inline-block after:block after:h-[2px] after:bg-amber-400 after:scale-x-0 after:transition-transform after:origin-left hover:after:scale-x-100"
                >
                  Research Journals
                </a>
              </li>
              <li>
                <a
                  href="/journal_articles"
                  className="relative inline-block after:block after:h-[2px] after:bg-amber-400 after:scale-x-0 after:transition-transform after:origin-left hover:after:scale-x-100"
                >
                  Research Articles
                </a>
              </li>
            </ul>
          </div>


          {/* Quick Links with hover animation */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-amber-400">Quick Links</h4>
            <ul className="text-sm space-y-2 text-gray-300">
              {["Courses", "Features", "Institutions", "Stats"].map((item) => (
                <li key={item}>
                  <a
                    href={`#${item.toLowerCase()}`}
                    className="relative inline-block after:block after:h-[2px] after:bg-amber-400 after:scale-x-0 after:transition-transform after:origin-left hover:after:scale-x-100"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>





          {/* Contact Info + Social Icons */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-amber-400">Connect</h4>
            <p className="text-sm text-gray-300 mb-1">
              Email: <a href="mailto:ebraryguru@gmail.com" className="hover:text-white">info@ebrary.guru</a>
            </p>
            <p className="text-sm text-gray-300 mb-4">
              WhatsApp:{" "}
              <a
                href="https://wa.me/919886688939"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white underline"
              >
                +91-9886688939
              </a>
            </p>

            <div className="flex gap-4">
              <a href="#" className="text-gray-300 hover:text-white transition"><FaFacebookF /></a>
              <a href="#" className="text-gray-300 hover:text-white transition"><FaTwitter /></a>
              <a href="#" className="text-gray-300 hover:text-white transition"><FaLinkedinIn /></a>
              <a href="#" className="text-gray-300 hover:text-white transition"><FaYoutube /></a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="mt-4 pt-6 text-center text-sm text-gray-400 border-t border-white/10">
          &copy; {new Date().getFullYear()} eBrary.guru. All rights reserved.
        </div>
      </footer>

    </div>
  )
}

export default SubjectDetails
